import { render, staticRenderFns } from "./WidgetsRemarks.vue?vue&type=template&id=8b66405c&scoped=true"
import script from "./WidgetsRemarks.vue?vue&type=script&lang=js"
export * from "./WidgetsRemarks.vue?vue&type=script&lang=js"
import style0 from "./WidgetsRemarks.vue?vue&type=style&index=0&id=8b66405c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b66405c",
  null
  
)

export default component.exports